<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Book Open" class="d-icon d-icon--book-open" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="m5.5 11.25-.005-.099a1 1 0 0 0-.995-.901H1a.5.5 0 0 1-.5-.5v-7.5a.5.5 0 0 1 .5-.5h3l.247.013a2.5 2.5 0 0 1 1.52.72c.086.084.162.177.233.272.071-.095.147-.188.232-.273A2.5 2.5 0 0 1 8 1.75h3l.1.01a.5.5 0 0 1 .4.49v7.5a.5.5 0 0 1-.5.5H7.5a1 1 0 0 0-1 1l-.01.1a.5.5 0 0 1-.98 0l-.01-.1Zm-4-2h3c.354 0 .698.095 1 .27V4.25l-.008-.148a1.5 1.5 0 0 0-1.344-1.344L4 2.75H1.5v6.5Zm5 .27c.302-.175.646-.27 1-.27h3v-6.5H8a1.5 1.5 0 0 0-1.5 1.5v5.27Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconBookOpen',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
